import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UpdatePasswordFormComponent } from '../../ui/update-password-form/update-password-form.component';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ResetpasswordService } from '../../data-access/resetpassword.service';
import { jwtDecode } from 'jwt-decode';
import { CommunicationType, ResetPasswordRequest} from '../../interfaces/reset-pwd.interface';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'equine-ui-nx-update-password',
  standalone: true,
  imports: [CommonModule, UpdatePasswordFormComponent],
  templateUrl: './update-password.component.html',
  styleUrl: './update-password.component.scss',
})
export class UpdatePasswordComponent implements OnInit {
  token: any;
  decodedToken: any;
  loading: boolean = false;
  unsubscribe$ = new Subject<void>();
  isPwdUpdate: boolean = false;
  appName!: string;
  constructor(private router: Router, private rt: ActivatedRoute, private resetpasswordService: ResetpasswordService, private snackBar: MatSnackBar) { }
  ngOnInit(): void {
    this.getTokenDetails();
    this.rt.data.pipe(takeUntil(this.unsubscribe$))
    .subscribe((data: any)=>{
      this.appName = data.appName
      this.verify();
    });    
  }

  resetPasswordData(data: any) {
    this.loading = true;
    const resetPwdData: ResetPasswordRequest = {
      "email": this.decodedToken.email,
      "password": data.value.password,
      "confirmPassword": data.value.confirmPassword,
      appName: this.appName
    };

    this.loading = true;
    this.resetpasswordService
      .verifyOtp(CommunicationType.EMAIL, this.decodedToken.email, this.decodedToken.otp)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: (data) => {
          if (data.status) {
            this.snackBar.open(`Success: Verified Please Reset Password`, 'Dismiss', {duration: 3000, panelClass: ['success-snackbar']});
            this.resetPassword(resetPwdData);
          } else {
            const errorMessage = data?.message ? data.message : 'Unable to Verify';
            this.snackBar.open(`Error: ${errorMessage}`, 'Dismiss',  {duration: 3000, panelClass: ['error-snackbar']});
          }
          this.loading = false;
        },
        error: (err) => {
          this.loading = false;
          const errorMessage = Array.isArray(err?.error?.message) ? err.error.message[0] : err?.error?.message;
          this.snackBar.open(errorMessage, 'Dismiss',  {duration: 3000, panelClass: ['error-snackbar']});
        }
      })
  }

  public resetPassword(reserPwdData: ResetPasswordRequest) {
    this.loading = true;
    this.resetpasswordService
      .sendResetPassword(reserPwdData)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: (data) => {
          if (data.status) {
            this.snackBar.open(`Success: Password changed successfully.`, 'Dismiss',  {duration: 3000, panelClass: ['success-snackbar']});
            this.isPwdUpdate = true;
          } else {
            this.snackBar.open(`Error: Unable to reset password.`, 'Dismiss',  {duration: 3000, panelClass: ['error-snackbar']});
            this.isPwdUpdate = false;
          }
          this.loading = false;
        },
        error: (err) => {
          this.loading = false;
          this.snackBar.open(Array.isArray(err?.error?.message) ? err.error.message[0] : err?.error?.message, 'Dismiss', {duration: 3000, panelClass: ['error-snackbar']});
        }
      })
  }

  verify() {
    this.loading = true;
    this.resetpasswordService
      .verifyOtp(CommunicationType.EMAIL, this.decodedToken.email, this.decodedToken.otp, this.appName)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: (data) => {
          if (data.status) {
            this.snackBar.open(`Success: Verified Please reset your password`, 'Dismiss',  {duration: 3000, panelClass: ['success-snackbar']});
          } else {
            this.snackBar.open(`Error: Your reset password link got expired, please resend password link`, 'Dismiss',  {duration: 3000, panelClass: ['error-snackbar']});
            this.router.navigate(['account/resetPassword']);
          }
          this.loading = false;
        },
        error: (err) => {
          this.loading = false;
          const errorMessage = Array.isArray(err?.error?.message) ? err.error.message[0] : err?.error?.message;
          this.snackBar.open(errorMessage, 'Dismiss',  {duration: 3000, panelClass: ['error-snackbar']});
        }
      })
  }

  getTokenDetails() {
    this.token = this.rt.snapshot.paramMap.get('token');
    this.decodedToken = jwtDecode(this.token);
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
